export interface StatusDisplay {
  text: string;
  color: string;
}

/**
 * Get status display information for a given status string
 * @param status - The status string from the API
 * @param customMappings - Optional custom status mappings for specific dashboards
 * @returns Status display information with text and color class
 */
export const getStatusDisplay = (
  status: string,
  customMappings?: Record<string, StatusDisplay>
): StatusDisplay => {
  // Check custom mappings first (try both original and normalized versions)
  if (customMappings) {
    if (customMappings[status]) {
      return customMappings[status];
    }
    // Also check normalized uppercase version
    const normalizedKey = status.toUpperCase().replaceAll('_', '');
    if (customMappings[normalizedKey]) {
      return customMappings[normalizedKey];
    }
  }

  // Normalize status to uppercase for comparison
  const normalizedStatus = status.toUpperCase().replaceAll('_', '');

  switch (normalizedStatus) {
    case 'DRAFT':
      return { text: 'Draft', color: 'status-default' };
    case 'COMPILED':
      return { text: 'Compiled', color: 'status-default' };
    case 'ONSALE':
    case 'ON_SALE':
      return { text: 'On Sale', color: 'status-default' };
    case 'CLAIMED':
      return { text: 'Claimed', color: 'status-default' };
    case 'SAMPLECOLLECTIONINPROGRESS':
      return { text: 'Sample Collection In Progress', color: 'status-default' };
    case 'PREPARINGFORSHIPPINGTOLAB':
      return { text: 'Preparing for Shipping to Lab', color: 'status-default' };
    case 'SUCCESSFULLYPROCESSEDBYLAB':
      return { text: 'Results Available', color: 'status-ready' };
    case 'COMPLETED':
      return { text: 'Lab | Patient Results', color: 'status-completed' };
    default:
      return { text: status.replaceAll('_', ' '), color: 'status-default' };
  }
};

